import { Reference } from "@apollo/client";

import useMutationWithValidation from "@hooks/useMutationWithValidation";
import {
  InternalNoteDestroyDocument,
  InternalNoteDestroyMutation,
  InternalNoteDestroyMutationVariables
} from "@typing/Generated";

type Args = {
  consultId?: string | null;
  journeyId: string;
};

const useDestroyInternalNote = ({ journeyId }: Args) => {
  const [mutation] = useMutationWithValidation<InternalNoteDestroyMutation, InternalNoteDestroyMutationVariables>(
    InternalNoteDestroyDocument,
    "internalNote",
    {
      update: (store, { data }) => {
        //
        // Delete the note from the journey's full list of notes
        //
        try {
          store.modify({
            fields: {
              internalNotes(cachedRefs: readonly Reference[], { readField }) {
                return cachedRefs.filter(ref => data?.internalNoteDestroy?.id !== readField("id", ref));
              }
            },
            id: store.identify({ __typename: "Journey", id: journeyId })
          });
        } catch {}
      }
    }
  );
  return mutation;
};

export default useDestroyInternalNote;
